export default "/fonts/Acrom-Medium.ttf?843ac5cfc38b59da8188ec684e14ec6c";